import {useState} from 'react';
import PropTypes from 'prop-types'
import TextareaAutosize from 'react-autosize-textarea';
import styled, {keyframes} from 'styled-components';
import {useForm} from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import {IoSendOutline as SendIcon} from 'react-icons/io5';
import {ImSpinner11} from 'react-icons/im';
import Button from './ButtonCmp';

const Input = styled(TextareaAutosize)`
  box-sizing: border-box; 
  padding: 0.2rem 2.5rem 0.2rem 1rem;
  background-color: ${({ theme }) => theme && theme.background ? theme.background.overlay : '#fff'} !important;
  color: ${({ theme }) => theme  && theme.text ? theme.text.primary : '#000'} !important;
  border: none;
  outline: none;
  border-radius: 20px;
  flex: 1;
  cursor: ${({ disabled }) => disabled ? 'progress' : 'auto'};
  resize: none;
  max-height: 30px !important; // needs important to override component css
  
  ::placeholder {
    color: ${({ theme }) => theme && theme.text ? theme.text.primary : '#000'};
    opacity: 1;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const SpinnerIcon = styled(ImSpinner11)`
  animation: ${spin} 1s linear infinite;
`;

const ChatFormCmp = ({onSubmit, field, buttonType}) => {
  const {register, handleSubmit, reset, formState: {errors}} = useForm();
  const [formState, setFormState] = useState({processing: false});

  const onSubmitWrapper = async data => {
    setFormState(() => {
      return {processing: true};
    });

    try {
      await onSubmit(data);

      setFormState(() => {
        return {processing: false};
      });

      if (buttonType === 'send') reset();
    } catch (e) {
      setFormState(() => {
        return {processing: false};
      });

      console.log(e);
    }
  };

  const handleEnterPress = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      handleSubmit(onSubmitWrapper)();
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmitWrapper)} autoComplete="off" inline="true">
      <Input
        name={field.name}
        placeholder={field.placeholder} 
        disabled={formState.processing}
        errors={errors}
        {...register(field.name, field.validation)} 
        rows={1}
        maxRows={buttonType === "send" ? 5 : 1}
        maxLength={buttonType === "send" ? "140" : "20"}
        onKeyDown={handleEnterPress}
      />
      <Button 
        type="submit" 
        color={buttonType === "enter" ? "green" : null} 
        disabled={formState.processing}
      >
        {formState.processing ? (<SpinnerIcon />) : (<SendIcon />)}
      </Button>
    </Form>
  );
}

ChatFormCmp.propTypes = {
  onSubmit: PropTypes.func,
  field: PropTypes.object.isRequired,
  buttonType: PropTypes.string,
}

export default ChatFormCmp;
